/**
 * Attachment for the investigation (not tied to a specific field)
 * NOTE: ID field uses string type to support encrypted UUIDs
 *
 * Upload metadata (uploadedByUserId, uploadedByUserName, uploadedOn) may be
 * unavailable when mapping from CreateInvestigationAttachmentDto (investigation creation flow)
 * or when constructing attachments from upload confirmation (backend doesn't
 * return user info in confirm response). These fields are populated when
 * fetching from the attachments list endpoint.
 */
export class InvestigationAttachmentEntity {
  public id!: string;
  public fileName!: string;
  public filePath!: string;
  public fileSizeBytes!: number;
  public contentType!: string;
  public uploadedByUserId?: string;
  public uploadedByUserName?: string;
  public uploadedOn?: Date;
}
